module.exports = __webpack_public_path__ + "img/3dconexion.361d7220.webp";